import { KLAGE_ILEGGELSER } from "../actions/klager/klageAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const initiateState = {};
const klageIleggelserReducer = (state = initiateState, action) =>
  CreateNewReducer(state, action, KLAGE_ILEGGELSER);

export default klageIleggelserReducer;
